import React from "react";
//assets
import iconRobotTutorial from 'img/icon-robot-tutorial.svg';
//styles
import { Content, Description, Link, Tutorial, Img } from "./styles";

export const PortalTraining: React.FC = () => {

  return (
    <Link target="_blank" href="https://www.figma.com/proto/vDDh5I1ZrQCRLAo21B0F33/Tutorial_Portal_de_Cotacoes?page-id=0%3A1&type=design&node-id=1-649&viewport=295%2C814%2C0.08&t=0x6fwOavxC97vmkH-1&scaling=scale-down&starting-point-node-id=1%3A649&mode=design">
      <Img src={iconRobotTutorial} />
      <Content>
        <Description> Precisa de ajuda com o Portal?</Description>
        <Tutorial>Acesse tutorial</Tutorial>
      </Content>
    </Link>
  );
};